
import React, { Fragment, useState, useEffect, useRef } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { useTranslation } from 'react-i18next';

// import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import travelimg from '../tr.png';
import { Container, Form, Row, Col, Card, Button, CardBody } from "react-bootstrap";
import Cookies from 'js-cookie';
import { event } from "jquery";
import $ from 'jquery';
import './hoteldetails.css'

const { config } = require('../api/api');


function HotelSearchPage() {


  const base_url = config.baseURL;
  const country = {  
    DE:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#D80027" d="M0 0h513v342H0z"/><path d="M0 0h513v114H0z"/><path fill="#FFDA44" d="M0 228h513v114H0z"/></svg>',
    RU:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333"><path fill="#FFF" d="M0 85.33v341.332h512V85.33z"/><path fill="#0052B4" d="M0 85.333h512V426.67H0z"/><path fill="#FFF" d="M0 85.333h512v113.775H0z"/><path fill="#D80027" d="M0 312.884h512v113.775H0z"/></svg>'

   };


  const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';


  const { t } = useTranslation();
  const [vendorKey, setVendorkey] = useState('');

  const [formData, setFormData] = useState({
    insurancetype: '',
  });
  const [loading, setLoading] = useState(true);

  const selectOpt1 = useRef(null);
  const selectOpt2 = useRef(null);
  const selectOpt3 = useRef(null);
  const [citizenship, setCitizenship] = useState("");
  const [roomsCount,setRoomsCount]=useState(1);
  const [roomData, setRoomData] = useState([{ adult_qty: 1, children: [] }]);
  const [providerData,setProviderData]=useState([]);
  const [direction, setSelectDirectionname] = useState(null);
  const [etmtoken , setEtmtoken] = useState('')
  const [transferallvalue , setTrandfervalue] = useState([]);
  const [citizionshipvalue , setCitizionshipvalue] =useState([]);
  const [details,setDetails]=useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [timer, setTimer] = useState(null);
const [fromdate, setFromdatevalue] = useState(() => {
  const today = new Date();
  return today.toISOString().split('T')[0]; // "YYYY-MM-DD"
});
const [todate, setTodatevalue] = useState(() => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow.toISOString().split('T')[0]; // returns "YYYY-MM-DD"
});

  const dropdownRef = useRef(null);
  const [selectedDirection, setSelectedDirection]=useState({});
  const [hotelDirection,setHotelDirection]=useState([]);
  const [searchRadius,setSearchRadius]=useState("0 - 50");
  const [transfer,setTransfer]=useState("");
  const [sessionSearchData,setSessionSearchData]=useState(null);
  const directionRef=useRef(null);
  const fromdateRef=useRef(null);
  const todateRef=useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [directionErr,setDirectionErr]=useState(false);
  const [radiusKmErr,setRadiusKmErr]=useState(false)
  const [formSubmit,setFormSubmit]=useState(false);
  const [selectedProvider,setSelectedProvider] =useState([]);
  const [providerError,setProviderError]=useState(null);
  const [ searchDirection,setSearchDirection]=useState();

  const searchRadiusRef=useRef(null);

  const [searchRadiusOptions,setSearchRadiusOptions]=useState([
    {id:1,name:"0 - 1",radius:"1000"},
    {id:2,name:"0 - 5",radius:"5000"},
    {id:3,name:"0 - 10",radius:"10000"},
    {id:4,name:"0 - 25",radius:"25000"},
    {id:5,name:"0 - 50",radius:"50000"},
    {id:6,name:"0 - 75",radius:"75000"},
    {id:7,name:"0 - 100",radius:"100000"},
    {id:8,name:"0 - 300",radius:"300000"},
  ]);
 



  useEffect(() => {

    const postvData = { organization_name: "Superjet" };
   

    if (vendorKey === '' || vendorKey === null || vendorKey === undefined) {

      // setLoading(true);
      fetch(base_url + '/create_organization', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postvData),
      })
        .then(response => response.json())
        .then(data => {
          setVendorkey(data.result[0].vendor_key);

          fetch(base_url + '/hotel_login', {
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${data.result[0].vendor_key}`,
                  },
                })
                  .then(response => response.json())
                  .then(data => {
                    setEtmtoken(data.result.etm_auth_key);
                  const token=data.result.etm_auth_key;
                      const expiredtoken = new Date();
                            expiredtoken.setTime(expiredtoken.getTime() + (1 * 60 * 60 * 1000));
                            Cookies.set('auth_key', JSON.stringify(token), {
                              expires: expiredtoken,
                            });
                    
                
                
                  })
                  .catch(error => {
                    console.error('Error posting data:', error);
                  });
          
        })
        .catch(error => {
          console.error('Error posting data:', error);
        });


    }
  }, [vendorKey]);





  useEffect(() => {

      if ((vendorKey !== ''&& vendorKey!==undefined&& vendorKey!==null) &&( etmtoken !== '' &&  etmtoken !== undefined &&  etmtoken !== null)) {
      
      var valuedata = {
        'etmtoken': etmtoken
      }
        fetch(base_url + '/hotel_group', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${vendorKey}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(valuedata),

        })
          .then(response => response.json())
          .then(data => {

            setTrandfervalue(data.result.data);
            
          
          })
          .catch(error => {
            console.error('Error posting data:', error);
          });

            fetch(base_url+ '/hotel_provider', {
              method: 'POST',
              headers: {
                'Authorization': `Bearer ${vendorKey}`,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(valuedata),
            })
              .then(response => response.json())
              .then(data => {
                debugger
                setProviderData(data.result.data.original.data);
                const provider_ids=data.result.data.original.data.map((pro)=>pro.id)
                setSelectedProvider(provider_ids);
        // Set initial selection for all providers
      
               
              })
              .catch(error => {
                console.error('Error posting data:', error);
              });
              fetch(base_url + '/citizenship', {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${vendorKey}`,
                  'Content-Type': 'application/json',
                },
      
              })
                .then(response => response.json())
                .then(data => {
                  setCitizionshipvalue(data.result.data);
      
                })
                .catch(error => {
                  console.error('Error posting data:', error);
                });

                setLoading(false)
      }


  }, [vendorKey, etmtoken]);


  useEffect(() => {
    $(selectOpt1.current).select2();
     $(selectOpt1.current)
              .next(".select2-container")
              .find(".select2-selection--single")
              .each(function() {
                  $(this).addClass("hotel");  // Adds the "hotel" class alongside the existing classes
              });
    $(selectOpt1.current).on('select2:select', (e) => {
      
      const selectedValue = e.params.data.text;
      const selected_citizenship = e.params.data.id;
      if(selected_citizenship){
        $(selectOpt1.current)
        .next(".select2-container")
        .find(".select2-selection--single.hotel")
        .each(function() {
            $(this).removeClass("error");  // Adds the "omantal" class alongside the existing classes
        });
      }
      setCitizenship(selected_citizenship);
     

    });

    // Clean up Select2 instance on unmount
    return () => {
      $(selectOpt1.current).select2('destroy');
    };
  }, [vendorKey,sessionSearchData,lnstr]);



  useEffect(() => {
    const $select = $(selectOpt3.current);
  
    // Initialize Select2 only once with options
    $select.select2({
      minimumResultsForSearch: Infinity // hides the search bar
    });
  
    // Add custom class to style the selection element
    $select.next(".select2-container")
      .find(".select2-selection--single")
      .addClass("hotel");
  
    // Handle selection
    $select.on('select2:select', (e) => {
      const selectedValue = e.params.data.text;
      const transfer_data = e.params.data.id;
  
      if (transfer_data) {
        $select.next(".select2-container")
          .find(".select2-selection--single.hotel")
          .removeClass("error");
  
        setTransfer(transfer_data);
        // setSelectAirPortName(selectedValue); // optional, if needed
      }
    });
  
    // Cleanup on unmount or vendorKey change
    return () => {
      $select.off('select2:select');
      $select.select2('destroy');
    };
  }, [vendorKey,lnstr]);
  
    useEffect(() => {
    const $select = $(selectOpt2.current);
  
    // Initialize Select2 only once with options
    $select.select2({
      minimumResultsForSearch: Infinity // hides the search bar
    });
  
   
    // Add custom class to style the selection element
    $select.next(".select2-container")
      .find(".select2-selection--single")
      .addClass("hotel");
  
    // Handle selection
    $select.on('select2:select', (e) => {
       debugger
      const selectedValue = e.params.data.text;
      const radius_km = e.params.data.id;
     
      if ( radius_km ) {
        $select.next(".select2-container")
          .find(".select2-selection--single.hotel")
          .removeClass("error");
        setSearchRadius( radius_km);
        // setSelectAirPortName(selectedValue); // optional, if needed
      }
    });
  
    // Cleanup on unmount or vendorKey change
    return () => {
      $select.off('select2:select');
      $select.select2('destroy');
    };
  }, [vendorKey,lnstr]);
  
  
  // useEffect(()=>{
  //   const sess=()=>{
  //     debugger
  //   const session_search_data=sessionStorage.getItem("hotelSearchData");
  //   if(session_search_data!==undefined && session_search_data!==null && session_search_data!==""){
  //   //  debugger
  //    const search_data_obj=JSON.parse(session_search_data).searchdata;
  //    const parse_rooms_data=search_data_obj?.rooms?JSON.parse(search_data_obj?.rooms) :"";
  //    search_data_obj["rooms"]=parse_rooms_data;
     
  //  //  details
  //   setSelectDirectionname(search_data_obj.poi_name);
    
  //   setCitizenship(search_data_obj.residency); 
  //   setTransfer(search_data_obj.transfer_group_id);
  //   setSessionSearchData(search_data_obj);
  //   setFromdatevalue(search_data_obj.checkin_date);
  //   setTodatevalue(search_data_obj.checkout_date); 
   
  //   setSearchRadius(search_data_obj.radius);
  //   setRoomData(search_data_obj.rooms);
  //   setRoomsCount(search_data_obj.rooms.length);
  //  } 
  // }
  // if((vendorKey!==null&& vendorKey!=="" && vendorKey!==undefined)&&(etmtoken!==null&& etmtoken!=="" && etmtoken!==undefined)){
  //   // sessionStorage.clear();
  //   // sess();
  // }

  // },[vendorKey,etmtoken])
 


  const today = new Date().toISOString().split("T")[0];


// useEffect(()=>{

// const fetchDefaultCountries =   () => {
//   // debugger 

  
//     var input = {
//       'etmtoken':etmtoken,
//       'limit':"15",
//       'locale' : 'EN'
//     }
  
//       fetch( base_url  + '/get_popular_country', {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${vendorKey}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(input),
        
//       })
//         .then(response => response.json())
//         .then((data) => {
//           if (Array.isArray(data?.result?.data) && data.result.data.length > 0) {

//             // const names = data.result.data?.map((item) => item.name); 
//             setDetails(data?.result?.data);
            
          
                         
//            }
   
//   })
//     .catch(error => {
//           console.error('Error posting data:', error);
//         });
  
//     }

// //  debugger
//  if((direction==="" ||direction===null)&& ((vendorKey!=="" && vendorKey!==null && vendorKey!==undefined)&& (etmtoken!=="" && etmtoken!==null && etmtoken!==undefined))){
//   fetchDefaultCountries();
//  }
// },[direction,vendorKey,etmtoken])

 useEffect(() => {
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);
  const handleSubmit = async (event) => {
    event.preventDefault();

    sessionStorage.clear();

    setFormSubmit(true);
    var valid =true;
    debugger
    const providers_id = providerData?.map((item) => item.id);
    
    // const transfer_group=transfer? transferallvalue.filter((obj)=>{return obj.id===transfer}):"";
    
    // const residency=citizionshipvalue.filter(obj=>obj.name===citizenship)
    if( Object.keys(selectedDirection).length===0){
      directionRef.current.focus();
      directionRef.current.classList.add('is-invalid')
      // setDirectionErr(true);
      valid=false;
    }
  
    if(!fromdate){

      if(valid){
      fromdateRef.current.focus();
      }
       fromdateRef.current.classList.add('is-invalid');
      valid=false;
    }   
    if(!todate){
         if(valid){
      todateRef.current.focus();
    
         }
           todateRef.current.classList.add('is-invalid');
      valid=false;
    } 
    if (!citizenship) {
  const $select = $(selectOpt1.current);

  // Add error class
  $select
    .next(".select2-container")
    .find(".select2-selection--single")
    .addClass("error");

    if(valid){
  $select.select2("open");
    // Focus the search input inside Select2
  setTimeout(() => {
    document.querySelector(".select2-search__field")?.focus();
  }, 0); // small delay to ensure Select2 is rendered


    }
  valid = false;
}
    if(!searchRadius){
      //    if( valid ){
      //    searchRadiusRef.current.focus();
      //    }
      //    searchRadiusRef.current.classList.add("is-invalid");
      // // setRadiusKmErr(true);

      // valid=false;.

        const $select = $(selectOpt2.current);

  // Add error class
  $select
    .next(".select2-container")
    .find(".select2-selection--single")
    .addClass("error");

    if(valid){
  $select.select2("open");
    // Focus the search input inside Select2
  setTimeout(() => {
    document.querySelector(".select2-search__field")?.focus();
  }, 0); // small delay to ensure Select2 is rendered

    }
  valid = false;
    }
    if(!transfer){
     
      $(selectOpt3.current)
      .next(".select2-container")
      .find(".select2-selection--single.hotel")
      .each(function() {
          $(this).addClass("error");  // Adds the "hotel" class alongside the existing classes
      });
      if(valid){
         const $select = $(selectOpt3.current);
  $select.select2("open");

  const transfer_ele=document.getElementById("Transfer");
  if(transfer_ele){
   transfer_ele.scrollIntoView({behavior:"smooth",block:"center"})
  }
  

  //   // Focus the search input inside Select2
  // setTimeout(() => {
  //   document.querySelector(".select2-search__field")?.focus();
  // }, 0); // small delay to ensure Select2 is rendered

      }
      valid=false;
    }
    
    roomData.forEach((room,p_index)=>{
      room.children.forEach((age,c_index)=>{
            if(age===""){
              valid=false;
            }
      })
    });

    for(let i=0;i<roomData.length;i++){
      for(let j=0;j<roomData[i].children.length;j++){
        if(roomData[i].children[j].age===""){
          valid=false;
        }
      }
    }

    const arr_data=[ Object.keys(selectedDirection).length===0?"":"true",citizenship,transfer,selectedDirection,transfer,fromdate,searchRadius];

    for(let i=0;i<arr_data.length;i++){
        if(arr_data[i]===""|| arr_data[i]===null || arr_data[i]===undefined){
          valid=false;
        }
    }

    if(selectedProvider.length===0){
       setProviderError("Select a provider.");
        valid=false
    }
    if(valid){

     var fulldetails = {
      "etmtoken":etmtoken,
      "searchdata":{
      "checkin_date": fromdate,
      "checkout_date": todate,
      "destination_id":selectedDirection?.id || "", 
      "one_order_id": 0,
      "poi_latitude": selectedDirection?.latitude,
      "poi_longitude": selectedDirection?.longitude, 
      "poi_name": selectedDirection?.name,  
      "providers": providers_id,
      "radius": Number(searchRadius.replace("0 - ",""))*1000,
      "residency":citizenship,
      "rooms":JSON.stringify(roomData),
      "source_id":  selectedDirection?.source_id|| null,
      "target_uid": null,
      "transfer_group_id": transfer ||2,
      "travel_policy_id": 0,
      "travellers": []
      
  }
    }
    

    sessionStorage.setItem("hotelSearchData", JSON.stringify(fulldetails));
    window.location.href="/hotel-details";
}
};




 const toggleDropdown = () => {
    setIsOpen(!isOpen);
  }
  const handleRoomChange = (event) => {
    // debugger
   const room_count=parseInt(event.target.value, 10);
   setRoomsCount(room_count);
   if(roomData.length>room_count){
    setRoomData((prevData)=>{
      const data=prevData;
      for(let i=data.length;i>room_count;i--){
      data.pop({ adult_qty: 1, children: [] });
      }
      return data;
  });
  return
   }
    setRoomData((prevData)=>{
      const data=prevData;
      for(let i=data.length;i<room_count;i++){
      data.push({ adult_qty: 1, children: [] });
      }
      return data;
  });

  };
  const handleChange2 = (index, field, value,childIndex)=>{
    if(value>17 && value<0){
      return;
    }
    if(field==="age"){
    
      setRoomData((prev) => {
        const newData = [...prev];
        const updatedChildren = [...newData[index].children];
    
        updatedChildren[childIndex] = {
          ...updatedChildren[childIndex],
          age:value,
        };
    
        newData[index] = {
          ...newData[index],
          children: updatedChildren,
        };
    
        return newData;
      });
     
    }
  }
  const handleChange = (index, field, value) => {
    // debugger
    if(field==="adult_qty"){
    setRoomData((prev) => {
      const newData = [...prev];
      newData[index] = { ...newData[index], [field]: parseInt(value, 10) };
      return newData;
    });
  }
  else if(field==="children"){
    const child_count=parseInt(value,10);
    setRoomData((prev) => {
      const newData = [...prev];
      newData[index] = { ...newData[index], [field]: Array(child_count).fill({age:""})};
      return newData;
    });
  }


 };


const handleChangehotel = (event) => {
  const value = event.target.value;
  setSelectDirectionname(value);

  if(value.length>=1 ){
       setSelectedDirection({});
  }
  if (value.length > 2) {
    
    if (timer) {
      clearTimeout(timer);
    }
    const newTimer = setTimeout(() => {
      fetchHotelDestinations(value.split(",")[0]);
      setShowDropdown(true);
    }, 500); 
    setTimer(newTimer);
  } else {
    // fetchDefaultCountries();
    setShowDropdown(false);
    setDetails([]); 
  }
};
useEffect(()=>{
  const timeoutId = setTimeout(() => {
    if (direction?.trim() && details.length > 0 && sessionSearchData?.destination_id ) {
      const filtered = details.filter((obj) => {
        return (
          sessionSearchData?.poi_name === obj.name &&
          sessionSearchData.destination_id === obj.id
        );
      });

      if (filtered[0]) {
        setShowDropdown(false);
        setSelectDirectionname("");
        setSelectedDirection(filtered[0]);
      }
    }
  }, 500);

  return () => clearTimeout(timeoutId);
 
},[details,sessionSearchData])



useEffect(()=>{
  if(direction?.trim()){
    fetchHotelDestinations(direction.split(",")[0]);
  }
  debugger
},[direction])


 const fetchHotelDestinations=(searchText)=>{

    var input = {
      'etmtoken':etmtoken,
      'poi_name': searchText,
      'locale' : 'EN'
    }
  
    if (vendorKey !== '') {
      fetch(base_url + '/hotel_destinations', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${vendorKey}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(input),
        
      })
        .then(response => response.json())
        .then((data) => {
         
          if (Array.isArray(data?.result?.data) && data.result.data.length > 0) {
           
            // const namesList = data.result.data?.map((item) => item.name); 
            setDetails(data.result.data);
          
            setHotelDirection(data.result.meta.hotels);
          
          }
   
  })
    .catch(error => {
          console.error('Error posting data:', error);
        });
  
    }

  }


const handleProviderChange = (provider_id) => {
   

    if(!selectedProvider.includes(provider_id)) {
    // Add provider_id
    
    setSelectedProvider([...selectedProvider, provider_id]);
    setProviderError("");

  } else {
    // Remove provider_id
    const filter_provider = selectedProvider.filter((obj) => obj !== provider_id);
    if(filter_provider.length>0){
      setProviderError("");
    }
    else{
     setProviderError("Select a provider.");
    }
    setSelectedProvider(filter_provider);

};




}









// find selected direction from Api Data
const findDirectionDetails=(direc_name,city,address)=>{
  // debugger
 if(direc_name==="city"){ 

if(details.length>0){
 
    const filter_direction=details.filter((obj)=>{
        return city===obj.name && address===obj.country.name
    })
    if(filter_direction.length>0){
 setSearchDirection(direc_name);
    setSelectedDirection(filter_direction[0]);
    setSelectDirectionname("");
    // setDirectionErr(false);
    directionRef.current.classList.remove("is-invalid")


    }
}
 }
 else if(direc_name==="hotel"){
  if(hotelDirection.length>0){
    
    const filter_direction=hotelDirection.filter((obj)=>{
        return city===obj.name && address===obj.address
    })
    if(filter_direction.length>0){
       setSearchDirection(direc_name);
    setSelectedDirection(filter_direction[0]);
    setSelectDirectionname("");
    //  setDirectionErr(false);
     directionRef.current.classList.remove("is-invalid")
    }
}
 }
}

const handleChangeSearchRadius=(e)=>{
    const value=e.target.value;
    const radius = value.replace(/\D/g, "").trim();
   setSearchRadius(radius);
   setRadiusKmErr(false);
   searchRadiusRef.current.classList.remove("is-invalid");
}




return (    

  <Fragment>

    <Navbar />
      <div className="container"  >
        <div className="row">
          <Col md={1}></Col>

          <Col md={10} className="myforms my-5">

         

            <div className="card p-3 shadow"
              style={{
                //   width: '250px',
                //   height: '160px',
                boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
                Width: "100%",
                borderRadius: '1rem'
              }}>
                <div className="row justify-content-center">
                  <h2 className="text-center"><strong><u>{t("E-Hotels")}</u></strong></h2>
                

                </div>
              <form className="p-4" style={{ backgroundColor: 'rgba(255, 255, 255, 0.6)', borderRadius: '2.5rem' }}  onSubmit={handleSubmit}>
                {/* <br/> */}
                <div className="mb-3">
                <div className="row">
                <div className="col-md-6">
                  <h4><strong>{t("Directions")}</strong><span style={{ color: 'red', marginLeft: '2px' }}>*</span></h4>

<div style={{ position: "relative" }} ref={dropdownRef} >
<div style={{position:"relative"}}>
      <input
        type="text"
        ref={directionRef}
        className="hotel form-control"
        value={direction}
       onChange={handleChangehotel}
       onFocus={(e)=>{setShowDropdown(true)
       
       }}
       
      placeholder={Object.keys(selectedDirection).length>0?
      searchDirection==="city"?selectedDirection?.name+", "+selectedDirection?.country?.name:selectedDirection?.name+", "+selectedDirection.address
      // selectedDirection?.
      : lnstr==="en"?"Search city, hotel":"ابحث عن المدينة والفندق" }
     
     
      /> 
     {/* <div style={{position: "absolute",
    top: "6px",
    right: "16px",
    cursor:"pointer"}} 
    onClick={(e)=>{
    // debugger
     if(showDropdown===true){
      setShowDropdown(false)
      } else{
      setShowDropdown(true)
    }
    }}>
     <i class="fa-solid fa-caret-down" style={{
    color: "#888",
    fontSize: "12px"
}}></i>
     </div> */}
      </div>
      {showDropdown  && (details?.length > 0 || hotelDirection.length>0)&& (
        <ul
          style={{
            position: "absolute",
            width: "100%",
            background: "white",
            border: "1px solid #ccc",
            borderRadius: "5px",
            listStyle: "none",
            padding: 0,
            margin: 0,
            maxHeight: "250px",
            overflowY: "auto",
            zIndex: 1000,
          }}
        >
          <li style={{ padding: "8px"}}   
  //             onMouseEnter={(e) => {
  //      e.currentTarget.style.background = "#007bff";
  //      e.currentTarget.style.color="#fff";
  //         }}
  // onMouseLeave={(e) => {
  //   e.currentTarget.style.background = "";
  //   e.currentTarget.style.color="#666666"
  // }}
  >
           { t('Select')}
          </li>
          {details?.map((desti, index) => (
            <li
              key={index}
              style={{backgroundColor:desti?.name+", "+desti?.country?.name===direction?"#007bff":"",
              color:desti?.name+", "+desti?.country?.name===direction?"#fff":"#666666",
              padding: "8px", cursor: "pointer", borderBottom: "1px solid #eee"}}
              onClick={() => {
                setSelectDirectionname(desti?.name+", "+desti?.country?.name);
                findDirectionDetails("city",desti?.name,desti?.country?.name);
                setShowDropdown(false);
              }}
              onMouseEnter={(e) => {
    e.currentTarget.style.background = "#007bff";
    e.currentTarget.style.color = "#fff";
    const span = e.currentTarget.querySelector("span");
    if (span) span.style.color = "#fff";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.background = "";
    e.currentTarget.style.color = "#666666";
    const span = e.currentTarget.querySelector("span");
    if (span) span.style.color = "grey";
  }}
            >
              {t(desti?.name)}<br /><span style={{color:desti?.name+", "+desti?.country?.name===direction?"#fff":"grey",fontSize:"11px"}} > {desti?.name},&nbsp;{desti?.country?.name}</span>
            </li>
          ))}
          {hotelDirection?.map((hotel, index) => (
            <li
              key={index}
              onClick={() => {
                setSelectDirectionname(hotel?.name);
                findDirectionDetails("hotel",hotel?.name,hotel?.address);
                setShowDropdown(false);
              }}
              onMouseEnter={(e) => {
    e.currentTarget.style.background = "#007bff";
    e.currentTarget.style.color = "#fff";
    const span = e.currentTarget.querySelector("span");
    if (span) span.style.color = "#fff";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.background = "";
    e.currentTarget.style.color = "#666666";
    const span = e.currentTarget.querySelector("span");
    if (span) span.style.color = "grey";
  }}  
              style={{ padding: "8px", cursor: "pointer", borderBottom: "1px solid #eee" }}
            >
              {hotel?.name}<br /><span  style={{color:hotel?.name===hotelDirection?"#fff":"grey",fontSize:"11px"}} > {hotel?.address}</span>
            </li>
          ))}
        </ul>
      )}
    </div>


                </div>
                <div className="col-md-3">
                  <div className="mb-3">
                  <h4><strong>{t("From")}</strong><span style={{ color: 'red', marginLeft: '2px' }}>*</span></h4>
                  <input type="Date" ref={fromdateRef} className="form-control" value={fromdate} min={today} 
                  onChange={(e)=>{
                    setFromdatevalue(e.target.value);
                    fromdateRef.current.classList.remove('is-invalid');
                  }} />

                </div>
                </div>
                
                <div className="col-md-3">
                 <div className="mb-3">
                  <h4><strong>{t("To")}</strong><span style={{ color: 'red', marginLeft: '2px' }}>*</span></h4>
                  <input type="Date" ref={todateRef} className="form-control" value={todate} min={fromdate!==null?fromdate:today} 
                  onChange={(e)=>{
                    setTodatevalue(e.target.value);
                     todateRef.current.classList.remove('is-invalid');
                    }}  />
                </div>
                </div>
                </div>
                </div>
                
                <div className="row">
                <div className="col-md-6">
                <div className="mb-3">
                  <h4><strong>{t("Citizenship")}</strong><span style={{ color: 'red', marginLeft: '2px' }}>*</span></h4>

                  <select
                    ref={selectOpt1}
                    className="form-control"
                    style={{ borderRadius: '5px', height: '30px', width: '100%', maxWidth: '300px' }}
                    value={citizenship}
                  >
                    <option value={''} disabled>{t("Select")} </option>
                    {citizionshipvalue?.map((citizionname) => (
                      <option key={citizionname.code} value={citizionname.code}>{t(citizionname.name)}</option>
                    ))}
                  </select>

                </div>
                </div>

                <div className="col-md-6">
                <div className=" mb-3">
                  <h4><strong>{t("Search")} {t("radius")} , km </strong><span style={{ color: 'red', marginLeft: '2px' }}>*</span></h4>
                 {/* <input type="text" ref={searchRadiusRef} className="hotel form-control" value={searchRadius} onChange={handleChangeSearchRadius}
                
                  /> */}
                   <select
                    ref={selectOpt2}
                    className="form-control"
                    style={{ borderRadius: '5px', height: '30px', width: '100%', maxWidth: '300px' }}
                    value={searchRadius}
                  >
                    {/* <option value={''} disabled>{t("Select")} </option> */}
                    {searchRadiusOptions?.map((radius) => (
                      <option key={radius.id} value={radius.value}>{t(radius.name)}</option>
                    ))}
                  </select>
                </div>
                </div>
                </div>
                <div className="row">
                <div className="col-md-6">
                <div className=" mb-3">
                  <h4 id="Transfer"><strong>{t("Transfer")}</strong><span style={{ color: 'red', marginLeft: '2px' }}>*</span></h4>

                  <select
                    ref={selectOpt3}
                    className="form-control"
                    style={{ borderRadius: '5px', height: '30px', width: '100%', maxWidth: '300px' }}
                   
                    value={transfer}
                    >
                    <option value={''} disabled >{t('Select')} </option>
                    {transferallvalue?.map((valuename) => (
                      <option key={valuename.id} value={valuename.id}>{t(valuename.name)}</option>
                    ))}
                  </select>

                </div>
                </div>

                <div className="col-md-6">
                <div className=" mb-3">
                  <h4><strong>{t('Rooms')}</strong></h4>

                  <select
                    className="form-control"
                    style={{ height: '40px' }}
                    onChange={handleRoomChange}
                    value={roomsCount}
                 
                    >
                     {[1, 2, 3, 4]?.map((num) => (
                       <option key={num} value={num}>{num}</option>
                     ))}
                   </select>

                </div>
                </div>
                </div>
               
                <div>
        {roomData.map((_, index)=> (
        <div key={index} className="border mt-3 p-3">
          <h4><b>{t('Room')} {index + 1}</b></h4>
             <div className="row p-0">
            <div className="col-md-3">
              <div className="">
              <h5 className="mt-2">{t('Adults')}:</h5>

              <select
                    className="form-control mx-2"
                    value={roomData[index].adult_qty}
                    // style={{ borderRadius: '5px', height: '30px', width: '100%', maxWidth: '300px' }}
                   onChange={(e) => handleChange(index, "adult_qty", e.target.value)}>
                {[1, 2, 3, 4]?.map(num => (
                <option key={num} value={num}>{num}</option>
                ))}
              </select>
              </div>
              </div>


              <div className="col-md-3">
              <div className="">
              <h5 className="mt-2">{t('Children')}:</h5>

              <select
                    // ref={selectOpt2}
                    className="form-control mx-2"
                    // style={{ borderRadius: '5px', height: '30px', width: '100%', maxWidth: '300px' }}
                    value={roomData[index]?.children?.length || 0}
                    onChange={(e) => handleChange(index, "children", e.target.value)}>
                  {[0, 1, 2]?.map(num => (
                  <option key={num} value={num}>{num}</option>
                ))}
                    
          </select>
          </div>
          </div>
          {roomData[index].children.length > 0 && ( 
            
            <>
            {[...Array(roomData[index].children.length)]?.map((_, childIndex) => ( 
            <div className="col-md-3 mt-2" key={childIndex}>
             
           <h5 className="">Child's age:<span style={{ color: 'red', marginLeft: '2px' }}>*</span></h5>
            <input type="number" className={`hotel form-control ${roomData[index].children[childIndex].age>18?"is-invalid":""} ${formSubmit && roomData[index].children[childIndex].age==="" ?"is-invalid" :""}`}
            //  style={{border:`1px solid ${formSubmit && roomData[index].children[childIndex].age>18 ?"red" :"#ced4da"}`}}
              min="0" max="17"
               defaultValue="" value={roomData[index].children[childIndex].age}
               onChange={(e) => handleChange2(index, "age", e.target.value,childIndex)}          
             />  
              </div>
            ))}
             </>
          
            )}
     </div>
      </div>
        )) } 
    </div>
<div className="row mt-4 ">
  <div className="col-md-6">
    <div className="mb-3">
               {/* <h4><strong>Provider</strong></h4> */}
               <div className="d-flex">
                   {providerData?.map((providerObj, index) => (
         <div
  key={index}
  className={
    "btn border mr-3 d-flex "
  }
  style={{ width: "auto", height: "40px" ,backgroundColor:  selectedProvider?.includes(providerObj.id) ?"#3fd2f2":"white",color:selectedProvider?.includes(providerObj.id) ?"white":"black" }}
  id={`provider${index}`}
  onClick={(e) => {
    handleProviderChange(providerObj.id);
  }}
>
  <span
    id={index}
    className={
      "mr-2 align-item-center " 
    }
    style={{ width: "34px", height: "30px", overflow: "hidden",backgroundColor:  selectedProvider?.includes(providerObj.id) ?"#3fd2f2":"white",color:selectedProvider?.includes(providerObj.id) ?"white":"black" }}
    onClick={(e) => {
      handleProviderChange(providerObj.id);
    }}
    dangerouslySetInnerHTML={{ __html: country[providerObj.country] || "" }}
  ></span>
  {t(providerObj?.name)}
</div>

      ))}
    </div>
    <div style={{color:"red"}}>{providerError?providerError:""}</div>
               </div>
               </div>
               <div className="col-md-6">
                <div className="d-flex justify-content-md-end">
                  <button className="btn btn-primary" style={{width:"30%",height:"40px"}}>{t('Find')}</button>
                </div>
                </div>
                </div>
              </form>
              </div>
         
          </Col>

          <Col md={1}></Col>
          

        </div>
      </div>
   

    <Footer />

    {
      loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )
    }
  </Fragment >
);
}

export default HotelSearchPage;
